import React from "react";
import { HowItWorks } from "./HowItWorks";
import { WhatsIncluded } from "./WhatsIncluded";

export const BillingPageCustomPricing: React.FC = () => (
    <>
        <HowItWorks />
        <WhatsIncluded />
    </>
);
